import { makeStyles } from "@mui/styles";

const styles = makeStyles(theme => ({
  healthClientSelectContainer: {
    minWidth: "300px",
  }
}));
export default styles;